<div class="p-2 pb-14 flex-1 h-full  overflow-y-auto">
   <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border"
        [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
    <form [formGroup]="driverForm" (ngSubmit)="onSave()">
        <div>
            <ng-container *ngIf="source !== 'modal'">
            
            <h1 class="heading">
                {{driverId ? 'Edit' : 'Add'}}
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            </ng-container>

            <h2 class="heading">
                General Information
            </h2>
            <p class="text-sm-light">
                Please provide the following information.
            </p>
        </div>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 p-3 rounded-lg bg-white dark:bg-transparent">
            <div class="space-y-1">
                <label class="subheading">
                    First Name <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="firstName" type="text" [readOnly]="verification?.isFirstName" [ngClass]="verification.isFirstName ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>
                <div *ngIf="submitted && form.firstName.errors">
                    <p *ngIf="form.firstName.errors.required" class="pt-1 text-red-600 text-xs">
                        First Name is required
                    </p>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Middle Name
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="middleName" type="text" [readOnly]="verification?.isMiddleName" [ngClass]="verification.isMiddleName ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Last Name <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="lastName" type="text"  [readOnly]="verification.isLastName" [ngClass]="verification.isLastName ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>
                <div *ngIf="submitted && form.lastName.errors">
                    <p *ngIf="form.lastName.errors.required" class="pt-1 text-red-600 text-xs">
                        Last Name is required
                    </p>
                </div>
            </div>
            
            <!-- displayName -->
            <div class="space-y-1">
                <label class="subheading">
                    Display Name
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="displayName" type="text"  [readOnly]="verification.isDisplayName" [ngClass]="verification.isDisplayName ? '': 'border-red-600 dark:border-red-600'"/>
                    </div>
                </div>
            </div>

            <ng-container formGroupName="address">
                <div class="space-y-1">
                    <label class="subheading">
                        Address <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                             <!-- Input with googlePlace directive -->
                        <input *ngIf="!verification.address?.isName" googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeDriverOriginAddress()"
                        formControlName="name" type="text" [disabled]="verification.address?.isName"
                        [readOnly]="verification.address?.isName"
                        [ngClass]="verification.address?.isName ? '' : 'border-red-600 dark:border-red-600'" 
                        placeholder="Enter the address" />

                    <!-- Input without googlePlace directive -->
                    <input *ngIf="verification.address?.isName" (onSelect)="onSelectAddress($event)" (input)="onChangeDriverOriginAddress()" formControlName="name"
                        type="text" [disabled]="verification.address?.isName"
                        [readOnly]="verification.address?.isName"
                        [ngClass]="verification.address?.isName ? '' : 'border-red-600'"
                        placeholder="Enter the address" />
                        </div>
                    </div>
                
                    <div *ngIf="submitted">
                        <p *ngIf="addressForm.get('name')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            Address is required
                        </p>
                        <p *ngIf="addressForm?.errors?.invalidAddress"
                            class="mt-2 text-red-600 text-xs">
                            Invalid address (select from the dropdown)
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        City <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="city" type="text" [readOnly]="verification.address?.isCity" [ngClass]="verification.address?.isCity ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>

                    <div *ngIf="submitted && addressForm.get('city')?.errors">
                        <p *ngIf="addressForm.get('city')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            City is required
                        </p>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        State <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="state" type="text" [readOnly]="verification.address?.isState" [ngClass]="verification.address?.isState ? '': 'border-red-600 dark:border-red-600'" />
                        </div>
                    </div>
                    <div *ngIf="submitted && addressForm.get('state')?.errors">
                        <p *ngIf="addressForm.get('state')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            State is required
                        </p>
                    </div>
                </div>
                
            </ng-container>


            <div class="space-y-1">
                <label class="subheading">
                    Contact Number <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="phoneNumber" type="text" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" [readOnly]="verification.isPhoneNumber" [ngClass]="verification.isPhoneNumber ? '': 'border-red-600 dark:border-red-600'"  />
                    </div>
                </div>

                <div *ngIf="submitted && form.phoneNumber.errors">
                    <p *ngIf="form.phoneNumber.errors.required" class="pt-1 text-red-600 text-xs">
                        Contact Number is required
                    </p>
                    <p *ngIf="submitted && form.phoneNumber.errors?.minlength || submitted && form.phoneNumber.errors.maxlength"
                        class="pt-1 text-red-600 text-xs">
                        Minimum 10 digits are required and maximum 13 digits are allowed
                    </p>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Phone Number <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="contactNumber" type="text" class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" [readOnly]="verification.isContactNumber"
                            [ngClass]="verification.isContactNumber ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>
            
                <div *ngIf="submitted && form.contactNumber.errors">
                    <p *ngIf="form.contactNumber.errors.required" class="pt-1 text-red-600 text-xs">
                        Phone Number is required
                    </p>
                    <p *ngIf="submitted && form.contactNumber.errors?.minlength || submitted && form.contactNumber.errors.maxlength"
                        class="pt-1 text-red-600 text-xs">
                        Minimum 10 digits are required and maximum 13 digits are allowed
                    </p>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Email <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="email" type="email"  [readOnly]="verification.isEmail" [ngClass]="verification.isEmail ? '': 'border-red-600 dark:border-red-600'"  />
                    </div>
                </div>

                <div *ngIf="submitted && form.email.errors">
                    <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                        Email is required
                    </p>
                    <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                        Invalid Email format
                    </p>
                </div>
            </div>
            <!-- Driver Signature -->
            <div class="space-y-1 col-span-2">
                <label class="subheading">
                    Driver Signature
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <div class="flex flex-col sm:flex-row gap-2 items-center">
                            <div class="flex-1 w-full">
                                <input #driverSignatureImageInput type="file" accept="Image/*" [disabled]="verification.isSignature" [readOnly]="verification.isSignature" [ngClass]="verification.isSignature ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'" 
                                    (change)="uploadDocumentImages(driverSignatureImageInput, form.signature)"  />
                            </div>
                            <div class="flex-shrink-0 w-full sm:w-auto">
                                <button type="button" (click)="openSignatureModal()" [disabled]="verification.isSignature"
                                    class="w-full btn btn-secondary flex items-center justify-center gap-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.83 18.291a8.96 8.96 0 0 1-3.06 1.981l-1.758.556.556-1.758a8.96 8.96 0 0 1 1.981-3.06l12.722-12.722ZM16.862 4.487 19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>
                                    Draw Signature
                                </button>
                            </div>
                        </div>

                        <!-- Show the selected file name if image selected -->
                        <div class="flex gap-3 items-center mt-1" *ngIf="form.signature.value">
                            <div class="text-xs text-gray-500">
                                <a target="_blank" [href]="form.signature.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(form.signature.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="form.signature.value && !verification.isSignature">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="form.signature.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(form.signature, driverSignatureImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Profile Image -->
            <div class="col-span-full">
                <div class="">
                    <label class="subheading">
                        Profile Image
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                                <img src="{{profileImageURL ? profileImageURL : 'assets/images/profileImagePlaceholder.png' }}"
                                     alt="Profile Image" class="relative h-32 w-32 rounded-full border border-main-base" />
                                <label *ngIf="!verification.isProfileImageURL" for="Profile"
                                     class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                     <span>Change</span>
                                     <input #logoInput type="file" accept="image/*" style="width: 100%;" [hidden]="true"
                                         (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                         class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0"
                                         [disabled]="verification.isProfileImageURL" />
                                 </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="mt-4">
            <h2 class="heading">
                Driver's Documents
            </h2>
            <p class="text-sm-light">
                Please provide the following information and documents
            </p>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 p-3 rounded-lg bg-white dark:bg-transparent">

            <ng-container formGroupName="driverLicense">
                <div class="space-y-1">
                    <label class="subheading">
                        Front of Driver's License
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <!-- <input #licenseImage accept="image/*" type="file"
                                (change)="uploadDriverLicenseImage(licenseImage)" /> -->
                            <input #driverLicenseImageInput type="file" accept="Image/*" [disabled]="verification.driverLicense?.isImage" [readOnly]="verification.driverLicense?.isImage" [ngClass]="verification.driverLicense?.isImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'" 
                                (change)="uploadDocumentImages(driverLicenseImageInput, driverLicense.get('image'))"  />

                            <!-- Show the selected file name if image selected -->
                            <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500" *ngIf="driverLicense.get('image')?.value">
                                <a target="_blank" [href]="driverLicense.get('image')?.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(driverLicense.get('image')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="driverLicense.get('image')?.value && !verification.driverLicense?.isImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="driverLicense.get('image')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(driverLicense.get('image'), driverLicenseImageInput)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','image')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','image') }}
                    </p>
                </div>
                <!-- License Number -->
                <div class="space-y-1">
                    <label class="subheading">
                        License Number <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="number" type="text" [readOnly]="verification.driverLicense?.isNumber" [ngClass]="verification.driverLicense?.isNumber ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                    </div>
                    <div *ngIf="submitted && driverLicense.get('number')?.errors">
                        <p *ngIf="driverLicense.get('number')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            License Number is required
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','number')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','number') }}
                    </p>
                </div>
                <!-- License Issue Date -->
                <div class="space-y-1">
                    <label class="subheading">
                        License Issue Date <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <!-- <input [owlDateTimeTrigger]="issueDate" (ngModelChange)="onIssueDateChange($event)"
                                formControlName="preLicenseIssueDate" [owlDateTime]="issueDate" type="text" />
                            <owl-date-time [pickerType]="'calendar'" #issueDate></owl-date-time> -->
                            <input type="text" name="time" id="time" formControlName="issueDate" [readOnly]="true" [ngClass]="verification.driverLicense?.isIssueDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="issueDate" [owlDateTimeTrigger]="issueDate"
                                [max]="driverLicense.get('expireDate')?.value"  />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.driverLicense?.isIssueDate"
                                (afterPickerClosed)="onDateChange(driverLicense.get('issueDate'))"
                                #issueDate></owl-date-time>
                        </div>
                    </div>
                    <div *ngIf="submitted && driverLicense.get('issueDate')?.errors">
                        <p *ngIf="driverLicense.get('issueDate')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            License Issue Date is required
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','issueDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','issueDate') }}
                    </p>
                    <!-- <owl-date-time #issueDate [pickerType]="'calendar'"></owl-date-time> -->
                </div>

                <!-- License Expiration Date -->
                <div class="space-y-1">
                    <label class="subheading">
                        License Expiration Date <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">

                            <input type="text" name="time" id="time" formControlName="expireDate" [readOnly]="true" [ngClass]="verification.driverLicense?.isExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="expireDate" [owlDateTimeTrigger]="expireDate" 
                                [min]="driverLicense.get('issueDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.driverLicense?.isExpireDate"
                                (afterPickerClosed)="onDateChange(driverLicense.get('expireDate'))"
                                #expireDate></owl-date-time>
                        </div>

                    </div>
                    <div *ngIf="submitted && driverLicense.get('expireDate')?.errors">
                        <p *ngIf="driverLicense.get('expireDate')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            License Expiration Date is required
                        </p>
                        <p *ngIf="driverLicense.get('expireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                            Expiration Date must be after Issue Date
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','expireDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','expireDate') }}
                    </p>

                </div>
                <!-- License State Issued -->
                <div class="space-y-1">
                    <label class="subheading">
                        License State Issued
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="stateIssue" type="text" [readOnly]="verification.driverLicense?.isStateIssue" [ngClass]="verification.driverLicense?.isStateIssue ? '': 'border-red-600 dark:border-red-600'"  />
                        </div>
                    </div>

                    <div *ngIf="submitted && driverLicense.get('stateIssue')?.errors">
                        <p *ngIf="driverLicense.get('stateIssue')?.errors?.required" class="pt-1 text-red-600 text-xs">
                            License State Issued is required
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','stateIssue')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','stateIssue') }}
                    </p>
                </div>
            </ng-container>

            <!-- Date of Birth -->
            <div class="space-y-1">
                <label class="subheading">
                    Date of Birth <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1 datePicker">
                        <!-- <input formControlName="dob" type="text" /> -->
                        <input type="text" name="time" id="time" formControlName="dob" [readOnly]="true" [ngClass]="verification.isDob ? 'date-filled': 'date-empty'"
                        [owlDateTime]="dob" [owlDateTimeTrigger]="dob" [min]="getTimeRestrictions().min" [max]="getTimeRestrictions().max" />
                    <owl-date-time [pickerType]="'calendar'" [disabled]="verification.isDob"
                        (afterPickerClosed)="onDateChange(form.dob)"
                        #dob></owl-date-time>
                    </div>
                </div>

                <div *ngIf="submitted && form.dob.errors">
                    <p *ngIf="form.dob.errors.required" class="pt-1 text-red-600 text-xs">
                        Date of Birth is required
                    </p>

                    <p *ngIf="form.dob.errors?.owlDateTimeMax" class="pt-1 text-red-600 text-xs">
                        Date of Birth must be a past date
                    </p>
                </div>
            </div>
            <!-- Languages Spoken -->
            <div class="space-y-1">
                <label class="subheading">
                    Spoken Languages <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="languageSpoken" type="text" [readOnly]="verification.isLanguageSpoken" [ngClass]="verification.isLanguageSpoken ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>

                <div *ngIf="submitted && form.languageSpoken.errors">
                    <p *ngIf="form.languageSpoken.errors.required" class="pt-1 text-red-600 text-xs">
                         Spoken Languages are required
                    </p>
                </div>
            </div>

            <!-- attestation -->
            <div class="space-y-1">
                <label class="subheading">
                    Attestation <span class="text-red-600">*</span>
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input #attestation type="file" accept="Image/*" [disabled]="verification.isAttestation" [readOnly]="verification.isAttestation" [ngClass]="verification.isAttestation ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                            (change)="uploadDocumentImages(attestation, form.attestation)"  />

                        <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500" *ngIf="form.attestation.value">
                                <a target="_blank" [href]="form.attestation.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(form.attestation.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="form.attestation.value && !verification.isAttestation">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="form.attestation.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(form.attestation, attestation)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="submitted && form.attestation.errors">
                    <p *ngIf="form.attestation.errors?.required" class="pt-1 text-red-600 text-xs">
                        Attestation is required
                    </p>
                </div>
                <p *ngIf="getRejectionReason('driversDocuments','attestation')" class="text-sm text-primary mt-1">
                    {{ getRejectionReason('driversDocuments','attestation') }}
                </p>
            </div>

            <!--formGroupName  examinations -->

            <ng-container formGroupName="examinations">
                <!-- phyExamImage -->
                <div class="space-y-1">
                    <label class="subheading">
                        Latest Physical Exam
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <!-- <input formControlName="phyExamImage" type="file" /> -->
                            <!-- <input #phyExamImage accept="image/*" type="file"
                                (change)="uploadPhyExamImage(phyExamImage)" /> -->

                            <input #phyExamImage type="file" accept="Image/*"  [disabled]="verification.examinations?.isPhyExamImage" [readOnly]="verification.examinations?.isPhyExamImage" [ngClass]="verification.examinations?.isPhyExamImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(phyExamImage, examinations.get('phyExamImage'))"  />

                            <div class="flex justify-between items-center mt-1">
                                <div class="text-xs text-gray-500" *ngIf="examinations.get('phyExamImage')?.value">
                                    <a target="_blank" [href]="examinations.get('phyExamImage')?.value"
                                        class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                        {{ getFileName(examinations.get('phyExamImage')?.value) }}
                                    </a>
                                </div>
                                <div class="flex justify-end gap-2" *ngIf="examinations.get('phyExamImage')?.value && !verification.examinations?.isPhyExamImage">
                                    <button
                                        type="button"
                                        [appCopyToClipboard]="examinations.get('phyExamImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                        class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                        </svg>
                                    </button>
                                    <button
                                        (click)="deleteFile(examinations.get('phyExamImage'), phyExamImage)"
                                        class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                        <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','phyExamImage')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','phyExamImage') }}
                    </p>
                </div>

                <!-- phyExamDate -->
                <div class="space-y-1">
                    <label class="subheading">
                        Latest Physical Exam Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <!-- <input [owlDateTimeTrigger]="phyExamDate" (ngModelChange)="onPhyExameDateChange($event)"
                                formControlName="prePhyExamDate" [owlDateTime]="phyExamDate" type="text" />
                            <owl-date-time [pickerType]="'calendar'" #phyExamDate></owl-date-time> -->

                            <input type="text" name="time" id="time" formControlName="phyExamDate"  [readOnly]="true" [ngClass]="verification.examinations?.isPhyExamDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="phyExamDate" [owlDateTimeTrigger]="phyExamDate"
                                [max]="examinations.get('phyExamExpireDate')?.value"  />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.examinations?.isPhyExamDate"
                                (afterPickerClosed)="onDateChange(examinations.get('phyExamDate'))"
                                #phyExamDate></owl-date-time>
                        </div>


                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','phyExamDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','phyExamDate') }}
                    </p>
                </div>
                <!-- phyExamDate -->
                <div class="space-y-1">
                    <label class="subheading">
                        Latest Physical Exam Expiration Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <!-- <input [owlDateTimeTrigger]="phyExamDate" (ngModelChange)="onPhyExameDateChange($event)"
                                formControlName="prePhyExamDate" [owlDateTime]="phyExamDate" type="text" />
                            <owl-date-time [pickerType]="'calendar'" #phyExamDate></owl-date-time> -->

                            <input type="text" name="time" id="time" formControlName="phyExamExpireDate"  [readOnly]="true" [ngClass]="verification.examinations?.isPhyExamExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="phyExamExpireDate" [owlDateTimeTrigger]="phyExamExpireDate"
                                  [min]="examinations.get('phyExamDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.examinations?.isPhyExamExpireDate"
                                (afterPickerClosed)="onDateChange(examinations.get('phyExamExpireDate'))"
                                #phyExamExpireDate></owl-date-time>
                        </div>
                    </div>
                    <div *ngIf="submitted && examinations.get('phyExamExpireDate')?.errors">
                        <p *ngIf="examinations.get('phyExamExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                            Latest Physical Exam Expiration Date must be after Latest Physical Exam Date
                        </p>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','phyExamExpireDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','phyExamExpireDate') }}
                    </p>

                </div>

                <!-- drugTestImage -->
                <div class="space-y-1">
                    <label class="subheading">
                        Drug Test
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <!-- <input #drugTestImage accept="image/*" type="file"
                                (change)="uploadDrugTestImage(drugTestImage)" /> -->

                            <input #drugTestImage type="file" accept="Image/*" [disabled]="verification.examinations?.isDrugTestImage" [readOnly]="verification.examinations?.isDrugTestImage" [ngClass]="verification.examinations?.isDrugTestImage ? 'cursor-not-allowed opacity-100' : 'cursor-pointer border-red-600 dark:border-red-600'"
                                (change)="uploadDocumentImages(drugTestImage, examinations.get('drugTestImage'))"  />

                           <div class="flex justify-between items-center mt-1">
                            <div class="text-xs text-gray-500" *ngIf="examinations.get('drugTestImage')?.value">
                                <a target="_blank" [href]="examinations.get('drugTestImage')?.value"
                                    class="text-xs text-blue-700 underline underline-offset-4 hover:text-blue-800">
                                    {{ getFileName(examinations.get('drugTestImage')?.value) }}
                                </a>
                            </div>
                            <div class="flex justify-end gap-2" *ngIf="examinations.get('drugTestImage')?.value && !verification.examinations?.isDrugTestImage">
                                <button
                                    type="button"
                                    [appCopyToClipboard]="examinations.get('drugTestImage')?.value" copyLabel="document link" copyTooltip="Copy link"
                                    class="p-1 border border-zinc-400 rounded bg-white text-black dark:bg-black dark:text-white dark:border-white/40 flex items-center justify-center outline-none focus:outline-none hover:border-primary hover:text-primary dark:hover:border-primary dark:hover:text-primary transition-colors">
                                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                                    </svg>
                                </button>
                                <button
                                    (click)="deleteFile(examinations.get('drugTestImage'), drugTestImage)"
                                    class="p-1 border rounded bg-red-600 flex items-center justify-center outline-none focus:outline-none">
                                    <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                           </div>
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','drugTestImage')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','drugTestImage') }}
                    </p>

                </div>

                <!-- Drug Date -->
                <div class="space-y-1">
                    <label class="subheading">
                        Drug Test Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <input type="text" name="time" id="time" formControlName="drugTestDate"  [readOnly]="true" [ngClass]="verification.examinations?.isDrugTestDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="drugTestDate" [owlDateTimeTrigger]="drugTestDate"
                                [max]="examinations.get('drugTestExpireDate')?.value" />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.examinations?.isDrugTestDate"
                                (afterPickerClosed)="onDateChange(examinations.get('drugTestDate'))"
                                #drugTestDate></owl-date-time>
                        </div>
                    </div>
                    <p *ngIf="getRejectionReason('driversDocuments','drugTestDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','drugTestDate') }}
                    </p>

                </div>
                <!-- Drug Date -->
                <div class="space-y-1">
                    <label class="subheading">
                        Drug Test Expiration Date
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 datePicker">
                            <input type="text" name="time" id="time" formControlName="drugTestExpireDate"  [readOnly]="true" [ngClass]="verification.examinations?.isDrugTestExpireDate ? 'date-filled': 'date-empty'"
                                [owlDateTime]="drugTestExpireDate" [owlDateTimeTrigger]="drugTestExpireDate"
                                [min]="examinations.get('drugTestDate')?.value"  />
                            <owl-date-time [pickerType]="'calendar'" [disabled]="verification.examinations?.isDrugTestExpireDate"
                                (afterPickerClosed)="onDateChange(examinations.get('drugTestExpireDate'))"
                                #drugTestExpireDate></owl-date-time>
                        </div>
                    </div>
                     <div *ngIf="submitted && examinations.get('drugTestExpireDate')?.errors">
                            <p *ngIf="examinations.get('drugTestExpireDate')?.errors?.dateMismatch" class="pt-1 text-red-600 text-xs">
                                Drug Test Expiration Date must be after Drug Test Date
                            </p>
                        </div>
                    <p *ngIf="getRejectionReason('driversDocuments','drugTestExpireDate')" class="text-sm text-primary mt-1">
                        {{ getRejectionReason('driversDocuments','drugTestExpireDate') }}
                    </p>

                </div>
            </ng-container>


            <div class="space-y-1">
                <label class="subheading">
                    Convicted of child abuse or felony in last 5 years?
                </label>
                <div>
                    <div>
                        <select formControlName="abuse"  [ngClass]="verification.isAbuse ? '': 'border-red-600 dark:border-red-600'" >
                            <option [disabled]="verification.isAbuse" [value]="true">Yes</option>
                            <option [disabled]="verification.isAbuse" [value]="false">No</option>
                        </select>
                    </div>
                   
                </div>
            </div>


            <div class="space-y-1">
                <label class="subheading">
                    Any vehicle violations in last 3 years?
                </label>
                <div>
                    <div>
                        <select formControlName="violations" [ngClass]="verification.isViolations ? '': 'border-red-600 dark:border-red-600'" >
                            <option  [disabled]="verification?.isViolations" [value]="true">Yes</option>
                            <option  [disabled]="verification?.isViolations" [value]="false">No</option>
                        </select>
                    </div>
                    
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Service Area(s)
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="serviceAreas" type="text" [readonly]="verification?.isServiceAreas" [ngClass]="verification.isServiceAreas ? '': 'border-red-600 dark:border-red-600'" />
                    </div>
                </div>

            </div>

            <div class="space-y-1">
                <label class="subheading">
                    Status
                </label>
                <div>
                    <div>
                        <select formControlName="isActive" class="">
                            <option [value]="true">Active</option>
                            <option [value]="false">Inactive</option>
                        </select>
                    </div>
                   
                </div>
            </div>
        </section>


        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">
            <button *ngIf="driverId && getInvalidFields().length" type="button" class="btn btn-secondary" (click)="sendInvalidFields()">
                Request Review
            </button>
            <button type="submit" class="btn btn-secondary">
                {{driverId ? 'Update' : 'Create'}}
            </button>
        </section>
    </form>
</div>
</div>
<app-trip-signature-modal *ngIf="signatureModalObj" [trip]="signatureModalObj" [source]="'driver'" (closeModal)="onCloseSignatureModal($event)"></app-trip-signature-modal>